import * as React from "react";
type Props = {
  className?: string,
};
function SvgSnacksLarge({ className }: Props) {
  return (
    <svg
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-SnacksLarge"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9542 46.3148C34.9239 46.3148 54.4482 25.4197 44.6272 23.2826C34.8062 21.1456 47.2584 1.19995 35.2887 1.19995C28.7929 1.19995 26.2809 10.2959 6.54978 5.94883C2.23891 4.99875 0.802297 13.0722 2.23891 26.3692C3.67604 39.6663 10.9845 46.3148 22.9542 46.3148Z"
        fill="#D6E4EE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.9172 15.8799C38.4728 16.5441 38.05 17.6179 38.5416 18.195C39.1558 18.9157 39.7964 18.1573 39.9616 17.4585C40.1543 16.6431 39.7004 15.7738 39.888 14.9856C40.0759 14.1944 40.8067 14.1348 41.474 13.613C43.1174 12.3279 44.2426 11.3084 44.2877 9.63517C44.3328 7.97027 43.2463 6.73824 41.7347 6.24096C40.6841 5.89571 39.5493 5.91586 38.5578 6.4149C37.7713 6.81097 37.1523 6.98885 36.3571 6.38466C35.7362 5.9128 35.1789 5.21836 34.4253 4.91166C33.6511 4.59621 32.9909 4.54801 32.1562 4.63783C30.2854 4.84025 29.2952 6.53538 29.4162 8.31113C29.5401 10.1303 31.0276 11.4981 31.7497 13.128C32.1348 13.9968 31.46 14.3924 30.8843 15.0378C30.4979 15.4702 30.1982 16.0582 30.3564 16.5774C30.7183 17.7656 31.8044 16.9958 32.3214 16.0985C32.8673 15.1513 33.2174 14.9707 34.5055 15.309C35.0856 15.4615 35.7025 15.546 36.3018 15.553C36.8096 15.5587 37.508 15.4667 37.9172 15.8799Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.2201 13.2977C34.2101 13.2675 34.1768 13.1619 34.2123 12.9731C34.3209 12.3934 35.2914 10.7614 35.8991 10.3469C36.0366 10.2532 36.2912 10.0915 36.5957 10.1441C36.8511 10.1879 37.0132 10.3618 37.1017 10.4591C37.3826 10.7684 37.5223 11.2534 37.5556 12.0307C37.5806 12.6116 37.5824 12.4565 37.5977 13.2092C37.6003 13.3267 37.6047 13.5155 37.5026 13.7113C37.3817 13.9431 37.2564 13.9799 37.1473 14.0018C36.8349 14.0535 36.5642 14.0483 36.3749 14.0443C35.5284 14.0255 34.9623 13.9002 34.5558 13.6614C34.4063 13.5738 34.2745 13.4634 34.2201 13.2977Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.534 11.3932C39.2313 10.4394 38.7349 9.74932 38.3603 9.31908C38.3226 9.26913 38.2652 9.23846 38.2525 9.16047C38.2253 8.99793 38.316 8.9379 38.3879 8.86123C38.7301 8.49451 39.3965 8.20797 39.7259 8.08968C40.1404 7.94115 40.6359 7.90785 40.7643 7.91223C40.8909 7.91618 41.3163 7.94597 41.6945 8.25573C42.2724 8.72891 42.3127 9.25511 42.2561 9.55392C42.2351 9.66564 42.2066 9.90705 42.0726 10.18C41.931 10.4687 41.758 10.7474 41.1223 11.4309C40.5045 12.0946 40.2477 12.3821 40.0151 12.3825C39.6874 12.3834 39.6567 11.7792 39.534 11.3932Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.4515 10.4349C34.0819 9.65761 34.7961 9.1967 35.3021 8.93294C35.3552 8.90052 35.42 8.89307 35.4603 8.82516C35.5449 8.68365 35.4822 8.59471 35.4437 8.497C35.2588 8.03083 34.744 7.5204 34.4802 7.28995C34.1485 6.9999 33.6995 6.78785 33.5785 6.74491C33.4589 6.70241 33.0523 6.57491 32.5875 6.72476C31.8764 6.9539 31.6464 7.42883 31.5898 7.72808C31.5684 7.8398 31.507 8.07464 31.5316 8.37783C31.5579 8.69854 31.6175 9.02101 31.9596 9.88939C32.2917 10.7328 32.4254 11.0947 32.6418 11.1801C32.9467 11.3002 33.1965 10.749 33.4515 10.4349Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.9172 15.8799C38.4728 16.5441 38.05 17.6179 38.5416 18.195C39.1558 18.9157 39.7964 18.1573 39.9616 17.4585C40.1543 16.6431 39.7004 15.7738 39.888 14.9856C40.0759 14.1944 40.8067 14.1348 41.474 13.613C43.1174 12.3279 44.2426 11.3084 44.2877 9.63517C44.3328 7.97027 43.2463 6.73824 41.7347 6.24096C40.6841 5.89571 39.5493 5.91586 38.5578 6.4149C37.7713 6.81097 37.1523 6.98885 36.3571 6.38466C35.7362 5.9128 35.1789 5.21836 34.4253 4.91166C33.6511 4.59621 32.9909 4.54801 32.1562 4.63783C30.2854 4.84025 29.2952 6.53538 29.4162 8.31113C29.5401 10.1303 31.0276 11.4981 31.7497 13.128C32.1348 13.9968 31.46 14.3924 30.8843 15.0378C30.4979 15.4702 30.1982 16.0582 30.3564 16.5774C30.7183 17.7656 31.8044 16.9958 32.3214 16.0985C32.8673 15.1513 33.2174 14.9707 34.5055 15.309C35.0856 15.4615 35.7025 15.546 36.3018 15.553C36.8096 15.5587 37.508 15.4667 37.9172 15.8799Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.7864 28.2933C21.6551 26.9815 21.6325 25.377 21.7856 24.745C21.9347 24.1311 22.1456 23.6581 22.2988 23.3568C22.3738 23.2457 22.9624 22.4041 23.9873 22.3811C24.7368 22.3644 25.2585 22.7953 25.4469 22.9552C26.4109 23.7756 26.4032 25.0395 26.3996 25.2103C26.3946 25.4583 26.3504 26.0139 26.0332 26.5641C25.076 28.2247 22.5278 28.2757 21.3596 28.2988C20.7132 28.3119 19.8852 28.264 18.9271 28.0467C18.7333 28.0033 18.4469 27.9365 18.0132 28.0575C17.8867 28.0928 17.1134 28.2933 16.8369 28.9804C16.5966 29.5785 16.8333 30.2941 17.1418 30.7006C18.2111 32.11 21.183 31.1921 21.4631 31.1027C23.771 30.3627 25.1781 27.9265 25.7206 26.9946"
        fill="white"
      />
      <path
        d="M20.7864 27.8082C21.6551 26.4964 21.6325 24.8919 21.7856 24.2599C21.9347 23.646 22.1456 23.173 22.2988 22.8717C22.3738 22.7606 22.9624 21.919 23.9874 21.896C24.7368 21.8793 25.2585 22.3102 25.4469 22.4701C26.4109 23.2905 26.4032 24.5544 26.3996 24.7252C26.3946 24.9732 26.3504 25.5288 26.0332 26.079C25.076 27.7396 22.5278 27.7906 21.3596 27.8137C20.7132 27.8268 19.8852 27.7789 18.9271 27.5616C18.7333 27.5182 18.4469 27.4514 18.0132 27.5724C17.8867 27.6077 17.1134 27.8082 16.8369 28.4953C16.5966 29.0934 16.8333 29.809 17.1418 30.2155C18.2111 31.6249 21.183 30.707 21.4631 30.6176C23.771 29.8776 25.1781 27.4414 25.7206 26.5095"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6205 5.09557C14.6237 4.99275 14.3586 7.16976 13.1775 7.62081C12.1445 8.01509 10.3349 6.82332 8.2616 8.81258C4.81995 12.1148 8.00993 16.7115 9.41135 17.9619C12.5647 20.7745 13.4963 20.6167 14.1534 20.6574C15.3362 20.6208 15.9571 19.3995 17.3979 18.7701C19.9044 17.813 22.9692 20.3892 22.9942 11.4474C22.9996 9.56895 22.0032 5.24577 17.6205 5.09557Z"
        fill="white"
      />
      <path d="M13.8467 14.575L14.4452 12.9622" stroke="currentColor" />
      <path
        d="M17.2849 13.3612L15.9385 12.2905"
        stroke="currentColor"
        strokeWidth={1.75}
      />
      <path
        d="M13.1774 7.62072C13.1774 7.62072 13.0629 4.26356 11.2529 3.33643"
        stroke="currentColor"
        strokeWidth={1.75}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6205 5.09557C14.6237 4.99275 14.3586 7.16976 13.1775 7.62081C12.1445 8.01509 10.3349 6.82332 8.2616 8.81258C4.81995 12.1148 8.00993 16.7115 9.41135 17.9619C12.5647 20.7745 13.4963 20.6167 14.1534 20.6574C15.3362 20.6208 15.9571 19.3995 17.3979 18.7701C19.9044 17.813 22.9692 20.3892 22.9942 11.4474C22.9996 9.56895 22.0032 5.24577 17.6205 5.09557Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5421 36.9362L11.7887 35.6897L12.5421 36.9362ZM13.7371 36.915L14.5606 35.7127L13.7371 36.915ZM10.577 38.4262L12.0162 38.1708L10.577 38.4262ZM13.8829 38.2925L15.2216 38.8513L13.8829 38.2925ZM12.628 40.5013L12.8324 39.0607L12.628 40.5013ZM15.2242 41.3613C15.4829 41.3286 15.7783 41.1056 15.8792 40.8655L17.17 37.8018C17.271 37.5618 17.2243 37.1963 17.0666 36.9899L15.0459 34.3449C14.8881 34.1377 14.5465 33.9951 14.2874 34.0279L10.9759 34.4466C10.7164 34.4798 10.4218 34.7028 10.3209 34.9424L9.03008 38.007C8.92874 38.2466 8.97577 38.6117 9.13355 38.819L11.1542 41.4639C11.312 41.6707 11.6536 41.8133 11.9127 41.7801L15.2242 41.3613Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3389 37.0866L11.3244 36.0415L12.3389 37.0866ZM13.4985 36.797L14.0305 35.4404L13.4985 36.797ZM10.7593 38.9804L12.1042 38.4078L10.7593 38.9804ZM13.9505 38.1065L15.3806 38.3498L13.9505 38.1065ZM13.2246 40.5409L13.0997 39.0913L13.2246 40.5409ZM15.9477 40.7949C16.1924 40.7048 16.4301 40.4211 16.4744 40.1645L17.043 36.889C17.0873 36.6324 16.9597 36.2867 16.7595 36.1211L14.1956 33.9985C13.9953 33.832 13.6303 33.77 13.3853 33.8602L10.2528 35.0131C10.0074 35.1039 9.77055 35.3874 9.72613 35.6436L9.15777 38.9199C9.11293 39.1762 9.2409 39.5214 9.44125 39.6878L12.0051 41.8104C12.2054 41.9765 12.5703 42.0385 12.8153 41.9479L15.9477 40.7949Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.2294 43.4568C31.5472 43.0788 30.8945 42.7013 30.1339 42.5086C29.2697 42.2892 27.9402 42.621 27.2975 41.8521C26.3621 40.7336 27.5768 38.4333 28.11 37.4009C28.7582 36.1442 29.5778 35.1214 29.7772 33.6786C29.9441 32.4635 29.8846 31.201 30.4998 30.0987C30.9889 29.2208 31.6104 28.5539 31.8485 27.5362C32.0829 26.5346 32.0675 25.4973 32.371 24.5082C32.5783 23.8338 32.8834 22.9389 33.4891 22.5251C34.3507 21.9394 35.3102 23.0067 36.02 23.4047C37.9161 24.4674 40.1973 23.9721 42.0709 25.1239C43.2265 25.834 42.3972 27.7705 41.9065 28.7188C41.3062 29.8793 40.5898 30.8176 40.3588 32.1405C40.1831 33.1325 39.99 34.005 39.4929 34.8966C38.7786 36.1763 38.1163 37.3318 37.8957 38.8121C37.6959 40.1558 37.7354 41.5832 37.1077 42.8224C36.5944 43.8406 35.7315 44.6915 34.5385 44.5067C33.7126 44.3789 32.9454 43.8544 32.2294 43.4568Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.6723 29.8443C33.8909 29.7886 32.9651 30.403 32.506 31.0611C32.0406 31.7292 32.0876 32.8099 33.0351 32.8174C34.0828 32.8269 36.2795 29.9601 34.6723 29.8443Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.6723 29.8443C33.8909 29.7886 32.9651 30.403 32.506 31.0611C32.0406 31.7292 32.0876 32.8099 33.0351 32.8174C34.0828 32.8269 36.2795 29.9601 34.6723 29.8443Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.0999 32.7607C35.6636 33.3168 35.2257 34.1993 35.7394 34.8237C36.0274 35.1755 36.7567 35.6017 37.1838 35.3074C38.0776 34.6909 37.1472 31.7258 36.0999 32.7607Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.0999 32.7607C35.6636 33.3168 35.2257 34.1993 35.7394 34.8237C36.0274 35.1755 36.7567 35.6017 37.1838 35.3074C38.0776 34.6909 37.1472 31.7258 36.0999 32.7607Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.9018 26.9713C33.9971 25.3332 37.5225 24.3675 37.341 26.0821C37.2577 26.8689 36.4331 27.726 35.8033 28.0552C35.0278 28.4615 33.8393 28.039 33.9018 26.9713Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.9018 26.9713C33.9971 25.3332 37.5225 24.3675 37.341 26.0821C37.2577 26.8689 36.4331 27.726 35.8033 28.0552C35.0278 28.4615 33.8393 28.039 33.9018 26.9713Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.2258 38.9864C33.964 38.571 33.9349 37.6868 34.3395 37.3522C34.8357 36.9438 35.5875 37.5749 35.9617 37.902C36.4596 38.337 36.8758 38.9527 36.1573 39.399C35.5696 39.7632 34.6009 39.5846 34.2258 38.9864Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.2258 38.9864C33.964 38.571 33.9349 37.6868 34.3395 37.3522C34.8357 36.9438 35.5875 37.5749 35.9617 37.902C36.4596 38.337 36.8758 38.9527 36.1573 39.399C35.5696 39.7632 34.6009 39.5846 34.2258 38.9864Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.6316 36.4479C30.9751 35.8555 31.6007 35.2028 32.1094 34.7982C32.7413 34.2941 34.0109 34.4931 33.4623 35.6066C33.1035 36.3359 32.3854 36.9157 31.7368 37.24C31.4455 37.3866 31.0783 37.568 30.7865 37.3891C30.4818 37.203 30.431 36.7942 30.6316 36.4479Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.6316 36.4479C30.9751 35.8555 31.6007 35.2028 32.1094 34.7982C32.7413 34.2941 34.0109 34.4931 33.4623 35.6066C33.1035 36.3359 32.3854 36.9157 31.7368 37.24C31.4455 37.3866 31.0783 37.568 30.7865 37.3891C30.4818 37.203 30.431 36.7942 30.6316 36.4479Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.5145 29.0185C36.7452 29.4668 37.0249 30.6344 37.4916 31.1656C37.7971 31.5144 38.5622 32.1126 39.0393 31.7971C39.8385 31.2692 39.1866 30.1761 38.8328 29.6499C38.5227 29.1883 38.1243 28.6621 37.5145 29.0185Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.5145 29.0185C36.7452 29.4668 37.0249 30.6344 37.4916 31.1656C37.7971 31.5144 38.5622 32.1126 39.0393 31.7971C39.8385 31.2692 39.1866 30.1761 38.8328 29.6499C38.5227 29.1883 38.1243 28.6621 37.5145 29.0185Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.5108 40.2291C30.5159 39.6776 31.2631 38.8151 31.8377 38.9228C32.4938 39.0455 32.7174 39.9304 32.6582 40.493C32.5968 41.0561 32.2102 42.0019 31.5021 41.7568C31.0596 41.6028 30.5065 40.7003 30.5108 40.2291Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.5108 40.2291C30.5159 39.6776 31.2631 38.8151 31.8377 38.9228C32.4938 39.0455 32.7174 39.9304 32.6582 40.493C32.5968 41.0561 32.2102 42.0019 31.5021 41.7568C31.0596 41.6028 30.5065 40.7003 30.5108 40.2291Z"
        stroke="currentColor"
      />
    </svg>
  );
}
export default SvgSnacksLarge;
